<template>
  <div>
    <v-toolbar flat color="white">
      <v-toolbar-title>
        <span >Balance Price: <b>{{balance_detail}}</b></span>
      </v-toolbar-title>
      
      <v-spacer></v-spacer>
    </v-toolbar>

    <p v-if="errors.length">
      <v-alert :value="true" color="primary" type="error" dismissible outline>{{ errors }}</v-alert>
    </p>

    <v-data-table
      :headers="headers"
      :items="record"
      active-class="highlighted"
      :disable-initial-sort="true"
      :rows-per-page-items="[100, 150, 200, 250]"
      class="elevation-5"
    >
      <v-progress-linear v-show="isLoading"></v-progress-linear>

      <template slot="items" slot-scope="props">
        <td class="text-xs"><h4>{{ props.item.sold_date }}</h4></td>
        <td class="text-xs">#DO{{ props.item.do_id }}</td>

        <td class="text-xs">{{ props.item.customer_name }}</td>
        <td class="text-xs">{{ props.item.total_weight }}</td>
        <td class="text-xs">RM{{ props.item.price }}/{{ props.item.type }}</td>
        
      </template>

 
    </v-data-table>

    <v-snackbar v-model="snackbar" :top="true">No Internet Connection
      <v-btn color="pink" flat @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import axios from "axios";
import baseUrl from "@/api/baseurl";


export default {
  data: () => ({
    isLoading: true,
    snackbar: false,
    dialog: false,
    errors: "",
    baseUrl: baseUrl,
    balance_detail:"",


    headers: [
    
      { text: "Sold Date", align: "", value: "sold_date" },
      { text: "DO", align: "", value: "do_id" },
      { text: "Customer", align: "", value: "customer_name" },
      { text: "Total KG/Box", align: "", value: "total_weight" },
      { text: "Price per KG/Box", align: "", value: "price" },
  
    ],
    record: []
  }),

  computed: {},

  watch: {},

  created() {
    // this.getrecord();
  },

  methods: {
    getrecord(balance_detail,vege_stocked_date,product_id) {
        this.balance_detail=balance_detail;
      const params = new URLSearchParams();
      params.append("getVegeSoldToWho", "getVegeSoldToWho");
      params.append("product_id", product_id);
      params.append("vege_stocked_date", vege_stocked_date);
 


      axios({
        method: "post",
        url: baseUrl + "/vege_web_v2/stock/balance_price.php",
        data: params
      })
        .then(response => {
          if (response.data.error == false) {
            this.snackbar = false;
            this.record = response.data.data;
            this.errors = "";
          } else if (response.data.error == true) {
            this.errors = response.data.message;
            this.record = [];
          }
        })
        .catch(error => {
          console.log(error);
          this.snackbar = true;
        });
    }
  }
};
</script>

 